import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import React from "react";
import { store, history } from "./store";
import Modal from "react-modal";

import { ConnectedRouter } from "react-router-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./components/App";


ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </BrowserRouter>
  </Provider>,

  document.getElementById("root")
);
